import { SET_USER_GEOLOCATION } from 'constants/actions';

type UserLocationState = {
  lat?: number;
  lon?: number;
};

export type SetUserLocationAction = {
  type: typeof SET_USER_GEOLOCATION;
  payload: UserLocationState;
};

const initialState: UserLocationState = {};

// eslint-disable-next-line default-param-last
const userLocation = (state = initialState, action: SetUserLocationAction) => {
  switch (action.type) {
    case SET_USER_GEOLOCATION:
      return action.payload;

    default:
      return state;
  }
};

export default userLocation;
